
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.5 7.6568L8.29945 12.5616C7.66235 13.1624 6.79824 13.5 5.89724 13.5C4.99624 13.5 4.13213 13.1624 3.49503 12.5616C2.85792 11.9607 2.5 11.1457 2.5 10.296C2.5 9.44622 2.85792 8.63126 3.49503 8.03039L8.69558 3.12562C9.12031 2.72504 9.69638 2.5 10.2971 2.5C10.8977 2.5 11.4738 2.72504 11.8985 3.12562C12.3233 3.5262 12.5619 4.06951 12.5619 4.63601C12.5619 5.20252 12.3233 5.74583 11.8985 6.14641L6.69232 11.0512C6.47995 11.2515 6.19192 11.364 5.89158 11.364C5.59125 11.364 5.30321 11.2515 5.09084 11.0512C4.87848 10.8509 4.75917 10.5792 4.75917 10.296C4.75917 10.0127 4.87848 9.74107 5.09084 9.54078L9.89527 5.01495","stroke":"#10001F","stroke-width":"1.4","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    